import stringToKebabCase from 'utils/textHelpers/stringToKebabCase';
import { RecentDestinationSearch } from '~/stores/recentSearches';

export function constructRecentDestinationSearchUrl(
  destination: RecentDestinationSearch,
): string {
  switch (destination.searchType) {
    case 'experiences': {
      const urlParts = ['s', stringToKebabCase(destination.country)];
      if (destination.city) {
        urlParts.push(stringToKebabCase(destination.city));
      }
      return `/${urlParts.join('/')}/`;
    }
    case 'locals': {
      const searchParams = new URLSearchParams();
      if (destination.country) {
        searchParams.set('country', stringToKebabCase(destination.country));
      }
      if (destination.city) {
        searchParams.set('city', stringToKebabCase(destination.city));
      }
      return `/l/?${searchParams.toString()}`;
    }
  }
}
